<template>
  <div class="terminal">

    <el-tabs type="border-card" @tab-click="showTab">
      <!-- 1 -->
      <el-tab-pane label="参数分组" style="margin-top: -20px;" >
        <div v-if="isShowTab">
        <div class="header">
          <el-button type="primary" size="small" @click="openAddFormVisible()">添加</el-button>
          <el-button type="primary" size="small" @click="dialogVisible1()">批量删除</el-button>
          <el-input
            class="search"
            size="small"
            placeholder="名称搜索"
            icon="el-icon-eleme"
            v-model="searchName"
            @keyup.enter.native="queryCommonGroupList" :on-icon-click="queryCommonGroupList"
            style="margin-left: 10px"
          ></el-input>
          <el-input
            class="search"
            size="small"
            placeholder="key搜索"
            icon="el-icon-eleme"
            v-model="searchKey"
            @keyup.enter.native="queryCommonGroupList" :on-icon-click="queryCommonGroupList"
            style="margin-left: 10px"
          ></el-input>
          <el-button type="primary" size="small" @click="queryCommonGroupList" style="margin-left: 10px">搜索</el-button>

          <el-dialog title="添加公共分组" :visible.sync="dialogCommonGroupFormVisible" width="40%" :close-on-click-modal="false">
            <el-form ref="form" :model="form" label-width="80px" size="small">
              <el-form-item label="名称"><el-input v-model="form.name" autocomplete="off"></el-input></el-form-item>
              <el-form-item label="key"><el-input v-model="form.key" autocomplete="off"></el-input></el-form-item>
              <el-form-item label="描述">
                <el-input type="textarea" v-model="form.groupDesc"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogCommonGroupFormVisible = false" size="small">取 消</el-button>
              <el-button type="primary" @click="save_commongroup()" size="small">确 定</el-button>
            </div>
          </el-dialog>


					<el-dialog
					  :visible.sync="dialogVisible"
					  width="30%"
					  :close-on-click-modal="false"
					 >
					  <span v-if = 'form.ids == 0'>请选择数据</span>
					  <p style="margin: 0px;height: 40px; line-height: 44px;" v-if = "form.ids != 0">
						  <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
						  <span style="float: left;">确定删除吗？</span>
					  </p>
					  <span slot="footer" class="dialog-footer">
					    <el-button @click="dialogVisible = false"  size="small">取 消</el-button>
					    <el-button type="primary" @click="deleteCommonGroup()"  size="small">确 定</el-button>
					  </span>
					</el-dialog>


        <!-- 分页 -->
          <el-pagination
            class="paging"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="form.pageNo"
            :page-size="form.pageSize"
            layout="total, prev, pager, next"
            :pager-count="7"
            :total="form.totalCount">
          </el-pagination>
        </div>
        <!-- style="width: 100%;border: 1px solid #EBEEF5;height: 400px;overflow-y: auto;" -->
        <div :style="{height:tableHeight - 40+'px'}">
          <el-table
            :maxHeight="tableHeight - 40+'px'"
            size="small"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            border
            @selection-change="multipleSelection = arguments[0]"
          >
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column label="名称" prop="name">

            </el-table-column>
            <el-table-column prop="npsKey" label="key"></el-table-column>
			<el-table-column prop="groupDesc" label="描述"></el-table-column>
            <el-table-column prop="createDate" label="时间"  width="220" align="center">
              <template slot-scope="scope">
                <p>{{formatCreateDate(scope.row)}}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="260" show-overflow-tooltip align="center">
              <template scope="scope">
                <el-button type="primary" size="small" @click="editCommonGroupHand(scope.row)">编辑</el-button>
                <el-button type="primary" size="small" @click="setCommonGroupParamHandler(scope.row.id)">设置参数</el-button>
                <!-- <el-button type="primary" size="small">查看</el-button> -->
                <el-button type="primary" size="small" @click="exportData(scope.row.id)">导出</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        </div>
      </el-tab-pane>

      <!-- 参数分组编辑 -->
      <el-dialog title="编辑" :visible.sync="dialogGroupFormVisibleEdit" width="40%" :close-on-click-modal="false">
        <el-form :model="form">
          <el-form-item label="名称" :label-width="formLabelWidth"  size="small"><el-input v-model="form.name" autocomplete="off"></el-input></el-form-item>
          <el-form-item label="key" :label-width="formLabelWidth"  size="small"><el-input v-model="form.key" autocomplete="off"></el-input></el-form-item>
          <el-form-item label="描述" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="form.groupDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogGroupFormVisibleEdit = false" size="small">取 消</el-button>
          <el-button type="primary" @click="editDialogCommonGroupHander()" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <!--设置参数   选共有分组-->
      <el-dialog title="选共有分组" :visible.sync="dialogTableVisible1" top="0" :close-on-click-modal="false">
        <div :style="{height:tableHeight - 80 +'px'}">
          <el-table
            ref="singleTable"
            :maxHeight="tableHeight - 80 + 'px'"
            :data="this.options"
            highlight-current-row
            border
            @current-change="handleCurrent"
            style="width: 100%">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column property="name" label="名称"></el-table-column>
            <el-table-column property="name" label="key"></el-table-column>
			<el-table-column prop="createDate" label="时间"  width="220" align="center">
			  <template slot-scope="scope">
			    <p>{{formatCreateDate(scope.row)}}</p>
			  </template>
			</el-table-column>

          </el-table>
        </div>
        <el-button type="primary" size="small"  @click="okSelectCommonGroup()" style="text-align: right;margin-top: 20px;position: relative;right: 0;bottom: 0;">确定</el-button>
		 <!-- <el-button type="primary" size="small"  @click="okSelectCommonGroup()" style="text-align: right;margin-top: 20px;position: relative;right: 0;bottom: 0;">引用</el-button> -->
      </el-dialog>

      <!-- 设置参数 -->
      <el-dialog title="设置参数" :visible.sync="dialogTableVisible" fullscreen>
        <el-button type="primary" size="small" :disabled="disabledSelectBt" @click="dialogFormVisible11 = true">添加一个</el-button>
        <el-button type="primary" size="small" :disabled="disabledSelectBt" @click="selectCommonGroupHandler()">选共有分组</el-button>
        <el-button type="primary" size="small" :disabled="disabledCommon" @click="saveBatchCommonGroupHandler()" >保存</el-button>
         <div :style="{height:tableHeight - 20+'px'}">
           <el-table
             :maxHeight="tableHeight - 20+'px'"
             :data="commonParamTable"
			 border
			 style="margin-top: 10px;"
			 size="small">
          <el-table-column label="key" >
            <template slot-scope="scope">
              <div  :class="{greenrecord:scope.row.cssFlag === 1,redrecord:scope.row.cssFlag === 2}">
                {{scope.row.name}}
              </div>
            </template>
          </el-table-column>
          <el-table-column property="paramInfo" label="value" ></el-table-column>
          <el-table-column  label="类型" >
            <template scope="scope">
              <div v-if="scope.row.type == type.INT.code">int</div>
              <div v-if="scope.row.type == type.STRING.code">string</div>
              <div v-if="scope.row.type == type.BOOLEAN.code">boolean</div>
			   <div v-if="scope.row.type == type.ARRAY.code">array</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <i class="el-icon-close" @click="handleDelete(scope.$index, scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
		</div>
      </el-dialog>
      <!--添加参数 -->
      <el-dialog title="添加参数" :visible.sync="dialogFormVisible11" width="40%" :close-on-click-modal="false">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="key"><el-input v-model="paramForm.name"></el-input></el-form-item>
          <!-- <el-form-item label="value"><el-input v-model="paramForm.paramInfo"></el-input></el-form-item> -->

		  <el-form-item label="value">
		    <el-input type="textarea" v-model="paramForm.paramInfo"></el-input>
		  </el-form-item>

          <el-form-item label="类型">
            <el-select v-model="selectParamTypevalue" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in paramTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" v-model="paramForm.paramDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible11 = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addParamHandler()" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 2 -->
      <el-tab-pane label="参数" style="margin-top: -20px;" >
        <common-param v-if="!isShowTab"></common-param>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
	import constants from '@/js/constants.js'
  import { mapState } from 'vuex';
  import api from '@/api/public/';
  import CommonParam from "./CommonParam";
  //添加一个的类型
  const type = constants.type;

  export default {
    components: {CommonParam},
    computed:{
      ...mapState('main', ['tableHeight'])
    },
    data() {
      return {
		dialogVisible: false,
        sertitle: '',
        isShowTab:true,
        tableData: [],
        options: [],
        type,
        disabledCommon:true,
        paramTypeOptions: constants.options,
        value: '',
        value1: '',
        selectParamTypevalue:'',
        selectGroupIdvalue: '',
        selectAddGroupIdvalue:'',
        tableParamData: [],
        totalParamCount:0,
        multipleSelection: [],
        handleSelectionChange: [],
        dialogGroupFormVisibleEdit:false,
        dialogFormVisibleEdit:false,
        dialogFormVisibleEdit1:false,
        dialogFormVisibleEdit2:false,
        dialogTableVisible: false,
        dialogTableVisible1: false,
        dialogCommonGroupFormVisible: false,
        dialogFormVisible11: false,
        dialogFormVisible111: false,
        dialogFormVisible2: false,
        dialogFormVisible3: false,
        searchKey:'',
        searchName:'',
        form: {
          name: '',
          key: '',
          groupDesc:'',
          ids: '',
          pageSize:15,
          pageNo: 1,//当前页码
          totalPage: 0,//总页数
          //paginationShow: true,//是否显示分页
          totalCount: 0,//总条数
        },
        paramForm: {
          name: '',
          paramInfo: '',
          paramDesc:'',
          id: '',
          ids: '',
          pageSize:15,
          pageNo: 1,//当前页码
          totalPage: 0,//总页数
          totalCount: 0,//总条数
        },
        formLabelWidth: '120px',
        token: "",
        commonParamTable:[],
        disabledSelectBt :false
      };
    },
    methods: {
      //改变每页显示数量时调用
      handleSizeChange(val) {
        this.$nextTick(() =>
          this.queryCommonGroupList(),
        )
      },
      //点击下一页和点击页码时执行
      handleCurrentChange(val) {
        this.form.pageNo = val;
        this.queryCommonGroupList();
      },
      handleCurrentChangeParam(val){
        this.paramForm.pageNo = val;
        this.queryCommonParamList();
      },
      //查询分组列表
      queryCommonGroupList(){
        var data = {
          'name':this.searchName,
          'key':this.searchKey,
          'pageNo':this.form.pageNo,
          'pageSize':this.form.pageSize,
          'token':this.token
        };
        api.queryCommonGroupList(data).then(res => {
          if(res.data.code == 0){
            this.tableData = res.data.data.list;
            this.form.totalCount = res.data.data.totalSize;
            //console.log(res);
          }else if(res.data.code ==-963){
            this.$cookies.remove('USER_TOKEN_COOKIE');
            this.$router.push('/login');
          }else{
            console.log(res.data.msg);
          }
        })
      },
      formatCreateDate: function(row) {
        let createDate = row.createDate;
        return window.formatDateTime(createDate);
      },
      // 保存
      save_commongroup(){

        var id = '';
        if(this.form.id){
          id = this.form.id;
        }else{
          id = '';
        }
        var data = {
          'id':id,
          'key':this.form.key,
          'name':this.form.name,
          'groupDesc':this.form.groupDesc,
          'token':this.token,
        };

        api.editCommonGroup(data)
          .then(res => {
            if(res.data.code == 0){
              this.clearAddParam();
              this.queryCommonGroupList();
              console.log(res.data.msg);
              this.dialogCommonGroupFormVisible = false;
              this.dialogGroupFormVisibleEdit = false;
            }else{
              console.log(res.data.msg);
            }
          })
      },
      openAddFormVisible(){
        this.dialogCommonGroupFormVisible = true;
        this.clearAddParam();
      },
      clearAddParam(){
        this.form.name = "";
        this.form.key = "";
        this.form.id = "";
        this.form.groupDesc = "";
      },
      clearAddCommonParam(){
        this.paramForm.name = "";
        this.paramForm.paramInfo = "";
        this.paramForm.id = "";
        this.paramForm.groupDesc = "";
        this.groupId = "";
      },
      addCommonParamHandler(){
        this.clearAddCommonParam();
        this.dialogFormVisible2 = true;
      },

			dialogVisible1(){
			   this.dialogVisible = true;
			   this.form.ids = this.multipleSelection.map(item => item.id);
			},
      // 删除
      deleteCommonGroup(){
        // this.form.ids = this.multipleSelection.map(item => item.id);
        // if(this.form.ids.length ==0){
        //   warningMsg({message:"请选择要删除的分组"});
        //   return;
        // }

				this.dialogVisible = false;
				var ids = [];
				if(this.form.ids.length == 0){
				    ids = this.form.ids;
				}else{
					ids = this.form.ids;

        var data = {
          'ids':this.form.ids,
          'token':this.token
        };
        api.delCommonGroup(data)
          .then(res => {
            if(res.data.code == 0){
				if(this.form.ids.length == 0){
				}else{
					this.clearAddParam();
					this.queryCommonGroupList();
					successMsg({
						   message: '删除成功'
					})
				}
            }else{
				errorMsg({
					   message: res.data.msg
				})
			}
          })
		  }
      },
      editCommonGroupHand( row ){
        this.dialogGroupFormVisibleEdit = true;
        this.form.name = row.name;
        this.form.key = row.npsKey;
        this.form.groupDesc = row.groupDesc;
        this.form.id = row.id;
      },
      editDialogCommonGroupHander(){
        this.save_commongroup();

      },
      //查询分组列表
      queryCommonGroupListAll(){
        var data = {
          'pageNo':1,
          'pageSize':10000,
          'token':this.token
        };
        api.queryCommonGroupList(data).then(res => {
          if(res.data.code == 0){
            this.options = res.data.data.list;
          }else{

          }
        })
      },
      editCommonParamHander(){
        this.saveCommonParam();
      },
      saveCommonParam(){
        var obj = {
          "name":this.paramForm.name,
          "paramInfo":this.paramForm.paramInfo,
          "type":this.selectParamTypevalue,
          "paramDesc":this.paramForm.paramDesc
        }
        var data = {
          "groupId":this.selectGroupIdvalue,
          "token":this.token,
          params:[obj]
        };
        api.saveCommonParam(data).then(res => {
          if(res.data.code == 0){
            this.dialogFormVisible2 = false;
            this.dialogFormVisible11 = false;
            this.queryCommonGroupParam(this.selectGroupIdvalue);
            this.clearAddCommonParam();

            successMsg({message:"保存成功"})
          }else{
            errorMsg({
              message: res.data.msg
            })
          }
        })
      },
      delCommonPara(){
        this.paramForm.ids = this.handleSelectionChange.map(item => item.id);
        if(this.paramForm.ids.length ==0){
          warningMsg({message:"请选择要删除的参数"});
          return;
        }
        var data = {
          'ids':this.paramForm.ids,
          'token':this.token
        };
        api.delCommonParam(data)
          .then(res => {
            if(res.data.code == 0){
              this.clearAddCommonParam();
              this.queryCommonParamList();
              successMsg({message:"删除成功"})
            }else{
              errorMsg({message:res.data.msg})
            }
          })
      },
      editParamHander( row ){
        console.log(row);
        this.dialogFormVisible2 = true;
        this.paramForm.name = row.name;
        this.paramForm.paramInfo = row.paramInfo;
        this.selectParamTypevalue =row.type;
        this.selectGroupIdvalue = row.groupId;
      },
      setCommonGroupParamHandler( groupId ){
        this.dialogTableVisible = true;
        this.disabledSelectBt = false;
        this.disabledCommon = true;
        //通过分组id查询分组下的参数
        this.queryCommonGroupParam(groupId);
        this.selectGroupIdvalue = groupId;
      },

      exportData(id){
        var data = {
          'groupId':id,
          'token':this.token
        };
        api.exportData(data)
          .then(res => {
            this.downFunction('commompara.txt',JSON.stringify(res.data,null,"\t"));
          })
      },
      downFunction(name, data) {
        var urlObject = window.URL || window.webkitURL || window;
        var export_blob = new Blob([data]);
        var save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
        save_link.href = urlObject.createObjectURL(export_blob);
        save_link.download = name;
        this.fakeClick(save_link);
      },
      fakeClick(obj){
        var ev = document.createEvent("MouseEvents");
        ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        obj.dispatchEvent(ev);
      },

      queryCommonGroupParam( groupId ){
        var data = {
          commonGroupId:groupId,
          token: this.token
        }

        api.querycommongroupparams(data)
          .then(res => {
            if(res.data.code == 0){
              this.commonParamTable = res.data.data;
            }else{
              errorMsg({message:res.data.msg})
            }
          })
      },
      addParamHandler(){
        this.saveCommonParam();
      },
      handleDelete(index, row){
		  if(!row.cssFlag){
			 // console.log("进来了")
			var data = {
			  paramId:row.id,
			  token: this.token
			}
			api.editCommonparamDeleteGrouId(data)
			  .then(res => {
			    if(res.data.code == 0){
			    }else{
			      errorMsg({message:res.data.msg})
			    }
			  })
		  }


        this.commonParamTable.splice(index,1);
        var name = row.name;
		console.log(row, index);
        for(let i=0;i<this.commonParamTable.length;i++){
          if(this.commonParamTable[i].cssFlag
            && this.commonParamTable[i].name == name
            && this.commonParamTable[i].cssFlag == 2 ){
            this.commonParamTable[i].cssFlag = 1;
          }
        }
      },
      handleCurrent(val){
        if(val){
          this.selectAddGroupIdvalue = val.id;
        }
      },
      selectCommonGroupHandler(){
        this.queryCommonGroupListAll();
        this.dialogTableVisible1 = true;

      },
      okSelectCommonGroup(){

        var data = {
          commonGroupId:this.selectAddGroupIdvalue,
          token: this.token,
        }

        var _this = this;
        api.querycommongroupparams(data)
          .then(res => {
            if(res.data.code == 0){
              var _commonParamTable = _this.commonParamTable;

              for(let i=0;i<res.data.data.length;i++){
                res.data.data[i].cssFlag = 1;
              }
              for(let i=0;i<res.data.data.length;i++){
                var obj = res.data.data[i];
                for(let j=0;j<_commonParamTable.length;j++){
                  if(obj.name == _this.commonParamTable[j].name){
                    res.data.data[i].cssFlag = 2;
                  }
                }
              }

              for(let i=0;i<res.data.data.length;i++){
                _this.commonParamTable.push(res.data.data[i]);
              }
              console.log(this.commonParamTable);
              this.dialogTableVisible1 = false;
              this.disabledSelectBt = true;
              this.disabledCommon = false;
            }else{
              errorMsg({message:res.data.msg})
            }
          })
      },
      saveBatchCommonGroupHandler(){
        var paramTable = this.commonParamTable;

        var paraArray = [];
        for(let i=0;i<paramTable.length;i++){
          if(paramTable[i].cssFlag == 2){
            errorMsg({message:"冲突，请删除红色部分"})
            return;
          }else {
            var obj = {
              "name":paramTable[i].name,
              "paramInfo":paramTable[i].paramInfo,
              "type":paramTable[i].type,
              "paramDesc":paramTable[i].paramDesc
            }
            paraArray.push(obj);
          }

        }
        var data = {
          groupId: this.selectGroupIdvalue,
          token: this.token,
          params: paraArray
        }
        api.saveCommonParamBatch( data )
          .then(res => {
            if(res.data.code == 0){
              successMsg({message:"保存成功"})
              this.dialogTableVisible = false;
              this.disabledCommon = true;
              this.queryCommonGroupParam(this.selectGroupIdvalue);
            }else{
              errorMsg({message:res.data.msg})
            }
          })
      },
      showTab(tab){
        if(tab.index =="0"){
        this.isShowTab = true;
        }else {
          this.isShowTab = false;
        }
      }
    },
    created() {
      // this.token = this.$cookies.get('USER_TOKEN_COOKIE');
      this.queryCommonGroupList();
      this.queryCommonGroupListAll();
    },
    mounted(){

    }
  };
</script>

<style scoped lang="less">
  .terminal {
    .crumbs {
      padding: 10px 0px;
    }
    .header {
      position: relative;
      height: 60px;
      line-height: 60px;
      .paging{
        position: absolute;
        right: 0px;
        top: 10px;
      }
      .search {
        width: 200px;
      }
    }

  }

  .greenrecord{
    color: #00FF00;
  }

  .redrecord{
    color: red;
  }
</style>
